const GAP = 30

const measureCaretPosition = (
  text: string,
  cursorPosition: number,
  className = '',
  maxWidth = '544px',
  caretEle = document.createElement('span'),
) => {
  if (!text.includes('#') && !text.includes('@') && !text.includes(':')) return

  const textBeforeCursor = text
    .slice(0, cursorPosition)
    .replace(new RegExp('\\n', 'g'), '<br>')
  const textAfterCursor = text.slice(cursorPosition)

  const pre = document.createElement('span')
  pre.innerHTML = textBeforeCursor

  const post = document.createTextNode(textAfterCursor)

  const mirroredEle = document.createElement('p')

  mirroredEle.className = className
  mirroredEle.style.maxWidth = maxWidth
  mirroredEle.append(pre, caretEle, post)

  document.body.appendChild(mirroredEle)
  const childPos = caretEle.getBoundingClientRect()
  document.body.removeChild(mirroredEle)

  const scrollOffset = window.scrollY > 100 ? window.scrollY : 0

  const positions = {
    top: Math.max(0, childPos.top + scrollOffset) + GAP,
    left: childPos.left + 4,
  }

  return positions
}

export default measureCaretPosition
